<template>
  <div>
    <el-card>
      <div class="d-flex headBox">
        <div class="d-flex">
          <div class="fs-20">企业名称：</div>
          <div class="fs-20">{{ name }}</div>
        </div>
        <div class="d-flex">
          <div class="fs-20">钱包余额：</div>
          <div class="fs-20 colorRed">{{ getFixed2(orgBalance) }}</div>
          <div class="fs-20">元</div>
        </div>
        <div class="d-flex">
          <el-button type="primary" permission="business.enterprise.corporatewallet.recharge" plain @click="recharge">充值</el-button>
          <el-button type="danger" permission="business.enterprise.corporatewallet.deduction" plain @click="refund">退款</el-button>
          <el-button type="primary" plain @click="cancel">返回</el-button>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px;">
      <div slot="header">
        <span style="font-weight:600;color:#000">钱包流水</span>
      </div>
      <STable
        ref="tableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
    <el-dialog
      v-if="rechargeVisible"
      v-dialogDrag
      title="充值"
      :visible.sync="rechargeVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="50%"
      center
    >
      <div style="width: 500px;">
        <el-form ref="rechargeFormRef" :model="rechargeForm" :rules="rechargeRules" label-width="100px">
          <el-form-item label="充值金额" prop="amount">
            <el-input v-model="rechargeForm.amount" placeholder="请输入充值金额" />
          </el-form-item><el-form-item label="备注" prop="remarks">
            <el-input v-model="rechargeForm.remarks" type="textarea" :rows="4" placeholder="请输入备注" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="rechargeSubmit()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="refundVisible"
      v-dialogDrag
      title="退款"
      :visible.sync="refundVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="50%"
      center
    >
      <div style="width: 500px;">
        <el-form ref="refundFormRef" :model="refundForm" :rules="refundRules" label-width="100px">
          <el-form-item label="退款金额" prop="amount">
            <el-input v-model="refundForm.amount" placeholder="请输入退款金额" />
          </el-form-item><el-form-item label="备注" prop="remarks">
            <el-input v-model="refundForm.remarks" type="textarea" :rows="4" placeholder="请输入备注" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="refundSubmit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      rechargeVisible: false, // 控制充值弹窗的显示
      refundVisible: false, // 控制退款弹窗的显示
      name: '',
      orgBalance: 0,
      id: '',
      // 充值表单
      rechargeForm: {
        amount: '', // 充值金额
        remarks: ''// 备注
      },
      rechargeRules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      // 退款表单
      refundForm: {
        amount: '', // 退款金额
        remarks: ''// 备注
      },
      refundRules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      url: '',
      columns: [
        {
          label: '流水号',
          prop: 'id'
        }, {
          label: '流水类型',
          prop: 'type'
        }, {
          label: '目标用户账号',
          prop: 'loginName'
        }, {
          label: '目标用户姓名',
          prop: 'username'
        }, {
          label: '流水金额（元）',
          prop: 'amount'
        }, {
          label: '备注',
          prop: 'remark'
        }, {
          label: '流水时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '目标用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '目标用户姓名',
          prop: 'username',
          placeholder: '请输入用户姓名'
        }, {
          label: '流水类型',
          prop: 'type',
          placeholder: '请选择流水类型',
          type: 'select',
          data: [{
            label: '补贴下发',
            value: 7
          }, {
            label: '补贴扣回',
            value: 8
          }, {
            label: '企业充值',
            value: 9
          }, {
            label: '企业退款',
            value: 10
          }]
        }, {
          label: '流水时间',
          prop: 'billTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          type: 'primary',
          before: (index, record) => {
            const url = HOST + '/org/billExport'
            const data = this.$refs.tableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                id: this.id,
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户列表失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  created() {
    this.id = this.$route.query.id
    this.url = '/org/billPage?id=' + this.id
  },

  mounted() {
    this.$nextTick(() => {
      this.getOrgBalance()
    })
  },
  methods: {
    // 充值
    recharge() {
      this.rechargeVisible = true
    },
    // 退款
    refund() {
      this.refundVisible = true
    },
    // 充值弹窗的提交
    rechargeSubmit() {
      let rechargeFormBool = false
      this.$refs['rechargeFormRef'].validate(valid => {
        rechargeFormBool = valid
      })

      // 表单校验通过
      if (rechargeFormBool) {
        const data = {
          id: this.id,
          rechargeAmount: this.rechargeForm.amount,
          remark: this.rechargeForm.remarks
        }
        this.$store.dispatch('form/handle', {
          url: '/org/recharge',
          data: data,
          method: 'post',
          callback: resp => {
          // 清空表单
            this.rechargeForm = {
              amount: '',
              remarks: ''
            },
            this.rechargeVisible = false
            this.refundVisible = false
            this.getOrgBalance()
            this.$refs.tableref.queryTable()
          }
        })
      }
    },
    // 退款弹窗的提交
    refundSubmit() {
      let refundFormBool = false
      this.$refs['refundFormRef'].validate(valid => {
        refundFormBool = valid
      })

      // 表单校验通过
      if (refundFormBool) {
        const data = {
          id: this.id,
          refundAmount: this.refundForm.amount,
          remark: this.refundForm.remarks
        }
        this.$store.dispatch('form/handle', {
          url: '/org/refund',
          data: data,
          method: 'post',
          callback: resp => {
          // 清空表单
            this.refundForm = {
              amount: '',
              remarks: ''
            },
            this.rechargeVisible = false
            this.refundVisible = false
            this.getOrgBalance()
            this.$refs.tableref.queryTable()
          }
        })
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.rechargeVisible = false
      this.refundVisible = false
      this.getOrgBalance()
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    },
    getOrgBalance() {
      this.$store.dispatch('form/handle', {
        url: '/org/getBalance?id=' + this.id,
        method: 'get',
        callback: resp => {
          if (resp) {
            this.name = resp.name
            this.orgBalance = resp.orgBalance
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .headBox{
    justify-content: space-between;
    align-items: center;
  }
  .colorRed{
    color: red;
  }
  .fs-20{
    font-size: 20px;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/organManagement/operatorWallet.vue